import React from "react";
import { Modal, Button } from "react-bootstrap";

const roleContent = {
  member: {
    title: "Welcome to LifeOnPlus – Member Dashboard",
    sections: [
      {
        icon: "❤️",
        heading: "Your Health. One App. Unlimited Access",
        text: `LifeOnPlus is a complete digital healthcare platform designed to make healthcare
        accessible, affordable, and convenient. Members can access multiple healthcare
        services from one platform without visiting multiple websites or locations.`,
        points: [
          "Book doctor consultations online",
          "Book lab tests and health packages",
          "Order medicines from verified pharmacies",
          "Access ambulance services quickly",
          "Use wellness and preventive healthcare services",
        ],
      },
      {
        icon: "📄",
        heading: "Digital Health Records",
        text: `Managing health records is very important. LifeOnPlus allows you to store and
        manage your health records securely in one place.`,
        points: [
          "Upload prescriptions and reports",
          "Store medical history",
          "Access reports anytime",
          "Share reports with doctors easily",
          "Track health progress over time",
        ],
      },
      {
        icon: "💰",
        heading: "Discounts, Offers & Wallet",
        text: `Members get exclusive discounts and wallet benefits across the LifeOnPlus
        healthcare network.`,
        points: [
          "Discounts on lab tests",
          "Discounts on medicines",
          "Cashback offers",
          "Wallet transactions tracking",
          "Transparent payment system",
        ],
      },
      {
        icon: "🧘",
        heading: "Wellness & Preventive Healthcare",
        text: `LifeOnPlus focuses not only on treatment but also on preventive healthcare
        and wellness programs.`,
        points: [
          "Body Recharge Stations",
          "Preventive health checkups",
          "Lifestyle wellness programs",
          "Stress management therapies",
          "Energy and wellness improvement programs",
        ],
      },
    ],
  },

  corporate: {
    title: "Corporate Healthcare Partnership – LifeOnPlus",
    sections: [
      {
        icon: "🏢",
        heading: "Smart Healthcare for Employees",
        text: `LifeOnPlus helps organizations provide healthcare and wellness benefits
        to employees through a digital healthcare platform.`,
        points: [
          "24/7 doctor consultations",
          "Diagnostic and lab test booking",
          "Medicine ordering",
          "Ambulance services",
          "Wellness programs for employees",
        ],
      },
      {
        icon: "📊",
        heading: "Corporate Dashboard & Analytics",
        text: `Companies can monitor employee wellness and healthcare usage using analytics dashboards.`,
        points: [
          "Healthcare usage reports",
          "Employee wellness trends",
          "Preventive healthcare tracking",
          "Department-wise health analytics",
          "Cost optimization reports",
        ],
      },
      {
        icon: "📉",
        heading: "Reduce Absenteeism & Improve Productivity",
        text: `Quick healthcare access reduces employee sick leave and improves productivity.`,
        points: [
          "Online consultations",
          "Preventive health programs",
          "Early disease detection",
          "Health awareness programs",
          "Employee wellness campaigns",
        ],
      },
    ],
  },

  vendor: {
    title: "LifeOnPlus Vendor Marketplace",
    sections: [
      {
        icon: "🛍️",
        heading: "Sell Healthcare Products Online",
        text: `Vendors can sell healthcare, wellness, and medical products through
        the LifeOnPlus digital marketplace.`,
        points: [
          "List products online",
          "Sell to clinics and hospitals",
          "Sell to corporates",
          "Sell directly to customers",
          "Pan India product reach",
        ],
      },
      {
        icon: "📦",
        heading: "Bulk Orders & Business Growth",
        text: `LifeOnPlus connects vendors with bulk buyers and healthcare providers.`,
        points: [
          "Bulk orders from clinics",
          "Bulk orders from labs",
          "Bulk orders from corporates",
          "Marketplace promotions",
          "Business growth opportunities",
        ],
      },
      {
        icon: "💳",
        heading: "Secure Payments & Order Tracking",
        text: `Track orders, payments, and settlements from vendor dashboard.`,
        points: [
          "Order tracking system",
          "Payment settlement reports",
          "Transaction history",
          "Secure payment gateway",
          "Transparent billing system",
        ],
      },
    ],
  },

  enduser: {
    title: "LifeOnPlus – Your Health. Your Control. Your App.",
    sections: [
      {
        icon: "📱",
        heading: "All Healthcare Services in One App",
        text: `LifeOnPlus allows users to access healthcare services easily from
        verified providers near their location.`,
        points: [
          "Doctor consultations",
          "Lab tests booking",
          "Medicine ordering",
          "Ambulance booking",
          "Health packages",
        ],
      },
      {
        icon: "🧘",
        heading: "Body Recharge Stations & Wellness",
        text: `Users can access non-invasive wellness therapies and preventive healthcare programs.`,
        points: [
          "Energy therapy",
          "Stress relief therapy",
          "Blood circulation improvement",
          "Preventive healthcare",
          "Wellness programs",
        ],
      },
      {
        icon: "🎁",
        heading: "Discounts & Smart Health Card",
        text: `Users get discounts, offers, and priority healthcare services.`,
        points: [
          "Discounts on services",
          "Special partner offers",
          "Priority bookings",
          "Health card benefits",
          "Wellness program discounts",
        ],
      },
    ],
  },
};

const RoleInfoModal = ({ show, handleClose, role }) => {
  const data = roleContent[role] || roleContent["member"];

  return (
    <Modal show={show} onHide={handleClose} size="xl" centered scrollable>
      <Modal.Header closeButton>
        <Modal.Title style={{ color: "#02BE0F", fontWeight: "600" }}>
          {data.title}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body
        style={{
          maxHeight: "70vh",
          overflowY: "auto",
          padding: "20px",
          background: "#f9f9f9",
        }}
      >
        {data.sections.map((section, index) => (
          <div
            key={index}
            style={{
              background: "#fff",
              padding: "18px",
              borderRadius: "10px",
              marginBottom: "15px",
              boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
              borderLeft: "5px solid #02BE0F",
            }}
          >
            <h5
              style={{
                color: "#02BE0F",
                fontWeight: "600",
                marginBottom: "8px",
              }}
            >
              <span style={{ marginRight: "8px" }}>{section.icon}</span>
              {section.heading}
            </h5>

            <p style={{ color: "#555", lineHeight: "1.7" }}>{section.text}</p>

            <ul style={{ paddingLeft: "20px", color: "#444" }}>
              {section.points.map((point, i) => (
                <li key={i} style={{ marginBottom: "5px" }}>
                  {point}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </Modal.Body>

      <Modal.Footer>
        <Button
          onClick={handleClose}
          style={{
            background: "#02BE0F",
            border: "none",
            padding: "8px 20px",
            fontWeight: "500",
          }}
        >
          Continue
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RoleInfoModal;
